/*
* Scheduled conditions
*
*/
import {monthsIndexed} from "../../../util";

export const ScheduledConditions = (typeFieldName) => {

  const today = new Date();
  return {
    type: 'field-group',
    name: 'scheduledCriteria',
    condition: {
      action: 'show', condition: {[typeFieldName]: {'_eq': 'scheduled'}}
    },
    fields: [
      {
        type: 'number',
        name: 'from_year',
        label: 'From Year',
        minValue: 2000,
      },
      {
        type: 'select',
        name: 'from_month',
        label: 'Month',
        choices: monthsIndexed,
      },
      {
        type: 'number',
        name: 'from_day',
        label: 'Day', minValue: 1,
        maxValue: 31,
      },
      {
        type: 'number',
        name: 'to_year',
        label: 'To Year',
        minValue: 2000,
      },
      {
        type: 'select',
        name: 'to_month',
        label: 'Month',
        choices: monthsIndexed,
      },
      {
        type: 'number',
        name: 'to_day',
        label: 'Day', minValue: 1,
        maxValue: 31,
      },
    ]
  }
}
